export enum RewardsTypes {
    GET_LIST_REWARDS = '@rewards/GET_LIST_REWARDS',
    REQUEST_GET_LIST_REWARDS = '@rewards/REQUEST_GET_LIST_REWARDS',
    SAVE_REWARD = '@rewards/SAVE_REWARD',
    REQUEST_SAVE_REWARD = '@rewards/REQUEST_SAVE_REWARD',
}

export type Reward = {
    id: string;
    name: Record<string, string>;
    image: string | '';
    type: string;
};

export type RewardsState = {
    isLoading: boolean;
    rewards: Reward[];
};

export type RewardsAction<Payload> = {
    type: RewardsTypes;
    payload: Payload;
};

export type RewardReducer = (state: RewardsState, actions: RewardsAction<RewardsState>) => RewardsState;
